import { actionTypes } from "./actions";

const initialState = {
  data: [],
  surveyEdit: {},
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.SET_SURVEY_INFO:
      return {
        ...state,
        data: payload,
      };

    case actionTypes.SET_SURVEY_POS_BY_ID:
      return {
        ...state,
        surveyEdit: payload,
      };

    default:
      return {
        ...state,
      };
  }
};
